/* tslint:disable */
/* eslint-disable */
export enum VpnLinkedState {
  NotLinked = 'NOT_LINKED',
  Linked = 'LINKED'
}
